import styled from "styled-components";

const GenericSearchResult = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #cdcdcd;
  border-radius: 7px;
  padding: 10px;
  margin-top: 5px;
  cursor: pointer;
`;

export default GenericSearchResult;
